// removed by extract-text-webpack-plugin
module.exports = {"seoContentContainer":"seoContentContainer__3Nsv9","seoContentHeading":"seoContentHeading__12xvn","seoContentDesc":"seoContentDesc__Ix-1L","quickLink":"quickLink__1GI5y","quickLinkFirst":"quickLinkFirst__Es51u"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/common/seoFooterContent/style.css
// module id = pxLK
// module chunks = 380